import { MDBBtn, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getAllUserInfo } from "../../Store/UserAction";
import { api } from "../../utils/axios";

const VerifyMobile = () => {
	const { current_user_id } = useParams();
	const [mobile, setMobile] = useState("");
	const [otp, setOtp] = useState("");
	const [sent, setSent] = useState(false);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleSendOTP = async () => {
		if (!mobile || mobile.length < 10) {
			toast.error("لطفاً شماره موبایل معتبر وارد کنید");
			return;
		}
		try {
			// Send the mobile number to the backend to request OTP
			const response = await api.post(
				"/sendOTP",
				{ mobile, current_user_id }, // ارسال داده‌ها در بدنه‌ی درخواست
				{
					headers: {
						Authorization: `Bearer ${localStorage.getItem("token")}`,
						"Content-Type": "application/json",
					},
				},
			);

			if (response.data.message === "OTP sent successfully") {
				toast.success("کد تأیید ارسال شد!");
				setSent(true);
			} else {
				toast.error("مشکلی در ارسال کد تأیید پیش آمد.");
			}
		} catch (error) {
			toast.error("خطا در ارتباط با سرور.");
		}
	};

	const handleVerifyOTP = async () => {
		if (otp.length !== 6) {
			toast.error("کد تأیید باید ۶ رقمی باشد!");
			return;
		}

		try {
			const response = await api.post(
				"/verifyOTP",
				{ otp, current_user_id }, // داده‌ها باید در آرگومان دوم ارسال شوند
				{
					headers: {
						Authorization: `Bearer ${localStorage.getItem("token")}`,
						"Content-Type": "application/json",
					},
				},
			);

			if (
				response.data.message ===
				"Mobile number verified and saved successfully"
			) {
				toast.success("شماره شما تأیید شد!");
				dispatch(getAllUserInfo()); // به‌روزرسانی داده‌های کاربر
				navigate("/home"); // Redirect after successful verification
			} else {
				toast.error("کد تأیید اشتباه است.");
			}
		} catch (error) {
			toast.error("خطا در ارتباط با سرور.");
		}
	};

	return (
		<div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-white">
			<div className="card p-4 shadow rounded" style={{ width: "400px" }}>
				<h5 className="text-center mb-3">تأیید شماره موبایل</h5>

				{!sent ? (
					<>
						<MDBInput
							label="شماره موبایل"
							icon="phone"
							type="tel"
							value={mobile}
							onChange={(e) => setMobile(e.target.value)}
						/>
						<MDBBtn
							className="mt-3 w-100"
							color="primary"
							onClick={handleSendOTP}
						>
							ارسال کد تأیید
						</MDBBtn>
					</>
				) : (
					<>
						<MDBInput
							label="کد تأیید"
							icon="key"
							type="text"
							value={otp}
							onChange={(e) => setOtp(e.target.value)}
						/>
						<MDBBtn
							className="mt-3 w-100"
							color="success"
							onClick={handleVerifyOTP}
						>
							تأیید کد
						</MDBBtn>
					</>
				)}
			</div>
		</div>
	);
};

export default VerifyMobile;
